import type { RecordMixedItemInput } from "@memorang/types";

const recordSummativeTestEvents = async (
	_input: RecordMixedItemInput,
): Promise<boolean> => {
	return true;
};

export { recordSummativeTestEvents };
